<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Forms and Bar Code Card P4.2">
     Forms and Bar Code Card P4.2
    </a>
   </p>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter" title="Overview">
     Overview
    </a>
   </p>
   <div id="divd0e8">
    <p class="toc-2-style">
     <a href="overview-chapter.html#supported-bar-codes" title="Supported bar codes">
      Supported bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="overview-chapter.html#supported-fonts-in-option-card" title="Supported fonts in the option card">
      Supported fonts in the option card
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="pcl5-hp-chapter.html#pcl5-hp-chapter" title="PCL 5 emulation: HP">
     PCL 5 emulation: HP
    </a>
   </p>
   <div id="divd0e505">
    <p class="toc-2-style">
     <a href="one-dimension-bar-codes-hp-topic.html#one-dimension-bar-codes-hp" title="One-dimensional bar codes">
      One-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="two-dimension-bar-codes-hp-topic.html#two-dimension-bar-codes-hp" title="Two-dimensional bar codes">
      Two-dimensional bar codes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="pcl5-lexmark-chapter.html#pcl5-lexmark-chapter" title="PCL 5 emulation: Lexmark">
     PCL 5 emulation: Lexmark
    </a>
   </p>
   <div id="divd0e3289">
    <p class="toc-2-style">
     <a href="pcl5-lexmark-chapter.html#one-dimension-bar-codes-lex" title="One-dimensional bar codes">
      One-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="pcl5-lexmark-chapter.html#two-dimension-bar-codes-lex" title="Two-dimensional bar codes">
      Two-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="pcl5-lexmark-chapter.html#composite-bar-codes-descriptor-lex" title="Composite bar codes">
      Composite bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="pcl5-lexmark-chapter.html#fonts-lex" title="Fonts">
      Fonts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="pcl5-lexmark-chapter.html#freescape-emulation-lex" title="FREESCAPE emulation">
      FREESCAPE emulation
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="postscript-chapter.html#postscript-chapter" title="PostScript emulation">
     PostScript emulation
    </a>
   </p>
   <div id="divd0e7434">
    <p class="toc-2-style">
     <a href="postscript-chapter.html#ps-operator" title="PostScript emulation operators">
      PostScript emulation operators
     </a>
    </p>
    <p class="toc-2-style">
     <a href="postscript-chapter.html#one-dimension-bar-codes-ps" title="One-dimensional bar codes">
      One-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="postscript-chapter.html#arguments-one-dimensional-bar-codes-ps" title="Arguments for one-dimensional bar codes">
      Arguments for one-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="postscript-chapter.html#two-dimension-bar-codes-ps" title="Two-dimensional bar codes">
      Two-dimensional bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="postscript-chapter.html#arguments-two-dimensional-bar-codes-ps" title="Arguments for two-dimensional bar code symbology">
      Arguments for two-dimensional bar code symbology
     </a>
    </p>
    <p class="toc-2-style">
     <a href="postscript-chapter.html#composite-bar-codes-ps" title="Composite bar codes">
      Composite bar codes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="forms-card-chapter.html#forms-card-chapter" title="Forms Card">
     Forms Card
    </a>
   </p>
   <div id="divd0e11159">
    <p class="toc-2-style">
     <a href="forms-card-chapter.html#features-fc" title="Features">
      Features
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-a-chapter.html#appendix-a-chapter" title="Appendix A - Feature summary">
     Appendix A - Feature summary
    </a>
   </p>
   <div id="divd0e12099">
   </div>
   <p class="toc-1-style">
    <a href="appendix-b-chapter.html#appendix-b-chapter" title="Appendix B - Supported bar codes">
     Appendix B - Supported bar codes
    </a>
   </p>
   <div id="divd0e12744">
   </div>
   <p class="toc-1-style">
    <a href="appendix-c-chapter.html#appendix-c-chapter" title="Appendix C - Forms Card fonts">
     Appendix C - Forms Card fonts
    </a>
   </p>
   <div id="divd0e14523">
   </div>
   <p class="toc-1-style">
    <a href="appendix-d-chapter.html#appendix-d-chapter" title="Appendix D - Forms print errors">
     Appendix D - Forms print errors
    </a>
   </p>
   <div id="divd0e17067">
   </div>
   <p class="toc-1-style">
    <a href="appendix-e-chapter.html#appendix-e-chapter" title="Appendix E - Bar code engine errors">
     Appendix E - Bar code engine errors
    </a>
   </p>
   <div id="divd0e17672">
    <p class="toc-2-style">
     <a href="appendix-e-chapter.html#common-error-messages" title="Common error messages">
      Common error messages
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-f-chapter.html#appendix-f-chapter" title="Appendix F - Deviations">
     Appendix F - Deviations
    </a>
   </p>
   <div id="divd0e18594">
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#code93-uppercase-versus-lowercase" title="Code 93 uppercase vs. lowercase">
      Code 93 uppercase vs. lowercase
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#codabar-uppercase-versus-lowercase" title="Codabar uppercase vs. lowercase">
      Codabar uppercase vs. lowercase
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#maximum-character-length" title="Maximum encodable character length">
      Maximum encodable character length
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#four-state-postal-widths" title="4-State postal widths">
      4-State postal widths
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#HRT-widths-heights" title="HRT widths and heights">
      HRT widths and heights
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#PDF417-image-widths-heights" title="PDF417 image widths and heights">
      PDF417 image widths and heights
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#MaxiCode-capacity" title="MaxiCode capacity">
      MaxiCode capacity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#bar-code-horizontal-alignment" title="Bar code horizontal alignment">
      Bar code horizontal alignment
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#PDF417-capacity" title="PDF417 capacity">
      PDF417 capacity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#MaxiCode-separtors-structured-appends" title="MaxiCode separators and structured appends">
      MaxiCode separators and structured appends
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#encoding-limits-bar-code" title="Encoding limits for bar codes">
      Encoding limits for bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#encoding-limits-codabar" title="Encoding limits for Codabar bar codes">
      Encoding limits for Codabar bar codes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#PostScript-bar-code-path-operator" title="PostScript emulation barcodepath operator">
      PostScript emulation barcodepath operator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#uploading-formsets-OFIS-data-filter-disabled" title="Uploading formsets when the OFIS data filter is disabled">
      Uploading formsets when the OFIS data filter is disabled
     </a>
    </p>
    <p class="toc-2-style">
     <a href="appendix-f-chapter.html#french-postal-3-of-9-dimensions" title="French Postal 3 of 9 dimensions">
      French Postal 3 of 9 dimensions
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e19050">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e19053" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue